import { render, staticRenderFns } from "./ChannelStatistics.vue?vue&type=template&id=492e62b6&"
import script from "./ChannelStatistics.vue?vue&type=script&lang=ts&"
export * from "./ChannelStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelStatistics.vue"
export default component.exports